// src/components/Pages/arcade/sanitizeGameConfig.ts
function clampCount(value, min) {
  return Number.isFinite(value) ? Math.max(min, Math.round(value)) : min;
}
function clampOptionalCount(value, min) {
  return value === void 0 ? void 0 : clampCount(value, min);
}
function clampOptionalDuration(value, min) {
  if (value === void 0) return void 0;
  return Number.isFinite(value) ? Math.max(min, value) : min;
}

export {
  clampCount,
  clampOptionalCount,
  clampOptionalDuration
};
//# sourceMappingURL=chunk-FSHWH3TV.mjs.map